'use client';

import { ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { ButtonBase, type ButtonComponentProps } from '../../common';
import { FilledDismiss } from '../../common/svgIcons';

interface NavigationButtonProps {
  to: string;
  icon?: ReactNode;
  visual?: ButtonComponentProps['visual'];
  size?: ButtonComponentProps['size'];
  ariaLabel?: string;
}

const NavigationButton = ({
  to,
  icon,
  size = 'small',
  visual = 'ghost',
  ariaLabel,
}: NavigationButtonProps) => {
  const router = useRouter();

  const navigate = () => router.push(to);

  return (
    <ButtonBase
      onClick={navigate}
      visual={visual}
      size={size}
      aria-label={ariaLabel || 'navigation button'}
    >
      {icon || <FilledDismiss size={24} />}
    </ButtonBase>
  );
};

export { NavigationButton };
